import img1d from './01d.jpg'
import img2d from './02d.jpg'
import img3d from './03d.jpg'
import img4d from './04d.jpg'
import img9d from './09d.jpg'
import img10d from './10d.jpg'
import img11d from './11d.jpg'
import img13d from './13d.jpg'
import img50d from './50d.jpg'
import img1n from './01n.jpg'
import img2n from './02n.jpg'
import img3n from './03n.jpg'
import img4n from './04n.jpg'
import img9n from './09n.jpg'
import img10n from './10n.jpg'
import img11n from './11n.jpg'
import img13n from './13n.jpg'
import img50n from './50n.jpg'

const bg = [img1d, img2d, img3d, img4d, img9d, img10d, img11d, img13d, img50d, img1n, img2n, img3n, img4n, img9n, img10n, img11n, img13n, img50n];

export default bg;